<template>
    <div class="input license-plate-input">
        <McSelect
            v-model="country"
            :options="countryOptions"
            :preset-value="{ key: country }"
            track-by="key"
            label-key="label"
            :enable-directive="false"
            @input="selectCountry"
        >
            <template #selectOption="{ option }">
                <span>{{ option.label }}</span>
            </template>
            <template #selectSingleLabel="{ option }">
                <div class="license-plate-input__option">
                    <svg-icon v-if="country === 'NO'" name="norway_flag" class="license-plate-input__icon" />
                    <svg-icon v-else name="eu" class="license-plate-input__icon icon-eu" />
                    <span>{{ option.label }}</span>
                </div>
            </template>
        </McSelect>
        <input v-model="text" type="text" class="license-plate-input__text" @input="emitValue" />
    </div>
</template>

<script>
import McSelect from './McSelect.vue';

export default {
    components: {
        McSelect,
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return {
                    country: this.$store.getters.siteCountryCodeWithFallback,
                    text: null,
                };
            },
        },
    },
    data() {
        return {
            text: this.value ? this.value.text : null,
            country: this.value ? this.value.country : this.$store.getters.siteCountryCodeWithFallback,
            countryOptions: [
                { key: 'SE', label: 'S' },
                { key: 'NO', label: 'N' },
                { key: 'FI', label: 'FIN' },
                { key: 'DK', label: 'DK' },
            ],
        };
    },
    methods: {
        emitValue() {
            if (!this.text || !this.country) {
                this.$emit('input', null);
            } else {
                this.$emit('input', { country: this.country, text: this.text.toUpperCase() });
            }
        },
        selectCountry() {
            // Avoid emitting if changing the country before entering text
            if (this.text) {
                this.emitValue();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

.license-plate-input {
    &.input {
        padding: 0;
        display: flex;
        flex-direction: row;
        height: 48px;
        border-color: $darkest-gray;
        border-width: 1px;
        background: #41479b;
        border-radius: $default-border-radius;

        @include lg {
            height: 64px;
        }
    }

    ::v-deep .mc-select .multiselect {
        background: #41479b;
        color: $white;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        min-height: auto;

        &__tags {
            background: #41479b;
            border: none;
            padding: 0 24px 0 4px;
            border-right: 1px solid $darkest-gray;
            min-height: auto;
        }

        &__single {
            height: 46px;
            padding: 2px 4px 0 0;
            margin: 0;
            border-right: 1px solid $darkest-gray;

            @include lg {
                height: 62px;
            }
        }

        &--active:not(.multiselect--above) {
            .multiselect__tags {
                border-color: $darkest-gray;
            }
        }

        &__content-wrapper {
            margin-top: 1px;
            left: 0;
            border: 1px solid $darkest-gray;
            border-top: none;
            border-radius: 0 0 $default-border-radius $default-border-radius;
        }

        &__tags,
        &__single,
        &__select,
        &--active:not(.multiselect--above) .multiselect__tags {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        &__select:before {
            top: -6px;
            right: 7px;
            border-color: $white;

            @include lg {
                top: 6px;
            }
        }

        &__option {
            background: #41479b;
            color: $white;
            padding: 8px 0;
            min-height: unset;
            @include font-size(14px);
            line-height: 14px;

            span {
                display: block;
                width: 31px;
                text-align: center;

                @include lg {
                    width: 38px;
                }
            }

            @include lg {
                @include font-size(22px);
                line-height: 22px;
                padding: 12px 0;
            }

            &--highlight,
            &:hover,
            &--selected.multiselect__option--highlight {
                background-color: #404dcc;
                color: $white;
            }
        }
    }

    ::v-deep &__option {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        @include font-size(14px);
        line-height: 14px;

        @include lg {
            @include font-size(22px);
            line-height: 22px;
        }
    }

    ::v-deep &__icon.svg-icon {
        margin-right: 0 !important;

        &.icon-eu {
            color: #ffe15a;
        }

        @include lg {
            width: 32px !important;
            height: 32px !important;
        }
    }

    &__text {
        -webkit-appearance: none;
        font-weight: bold;
        @include font-size(34px);
        color: $primary;
        padding-left: 16px;
        border: none;
        outline: none;
        margin: 0;
        width: 100%;
        border-radius: 0;
        border-top-right-radius: $default-border-radius;
        border-bottom-right-radius: $default-border-radius;
        text-transform: uppercase;
        letter-spacing: 2px;

        @include lg {
            padding-left: 24px;
        }
    }

    &.input:has(.multiselect--active) {
        border-bottom-left-radius: 0;
    }
}
</style>
